import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '../consts/url';
import { Contact, AccountContactGroup } from '../store/state/contacts/contacts.models';

@Injectable({
  providedIn: 'root',
})
export class ContactsService {
  constructor(private http: HttpClient) {}

  public getAllContacts(): Observable<Contact[]> {
    return this.http.get<Contact[]>(api.contacts.allContacts);
  }

  public getAccountContactGroups(accountId: string): Observable<AccountContactGroup[]> {
    return this.http.get<AccountContactGroup[]>(api.contacts.accountContactGroups(accountId));
  }
}
